module.exports = __webpack_public_path__ + "img/hotel-10a.cbe01a3c.jpeg";